module.exports = __webpack_public_path__ + "img/edit.b6e20c27.svg";